import React from "react"
import SystemMessage, {
  SystemMessageProps
} from "../../../mp-shared-components/generic-shared-components/components/SystemMessage/SystemMessage"
import { useStyles } from "./styles"
import { lightBlue } from "../../../mp-core/themes/palette"

type Props = SystemMessageProps & {
  iconColor?: string
  iconBgColor?: string
}

const ReportingSystemMessage: React.FC<Props> = ({
  outerClasses = {},
  iconColor = lightBlue[700],
  iconBgColor = lightBlue[100],
  ...props
}) => {
  const { classes, cx } = useStyles({ iconColor, iconBgColor })

  return (
    <SystemMessage
      {...props}
      outerClasses={{
        ...outerClasses,
        container: cx(classes.container, outerClasses.container),
        defaultIcon: cx(classes.defaultIcon, outerClasses.defaultIcon)
      }}
    />
  )
}

export default ReportingSystemMessage
